const onHandLowStock = (inventoryUnit, factorKg, onHandQty, articleWeight) => {
  //kg m pcs
  if (inventoryUnit == 'kg') {
    if (articleWeight > onHandQty) {
      return true;
    }
  } else if (inventoryUnit == 'm' || inventoryUnit == 'pcs') {
    let onHandWeight = (onHandQty / factorKg).toFixed(2);
    if (articleWeight > onHandWeight) {
      return true;
    }
  }
  return false;
};
export default onHandLowStock;
